<div class="row">
  <div class="col-md-12">
      <div class="card">
          <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
              <i class="material-icons"></i>
            </div>
            <h4 class="card-title" style="font-weight: 500;">Shipment #{{this.shipment.trackingNumber}}</h4>
          </div>
          <div class="card-body">
            <div mat-dialog-content>

                <div class="row" style="padding-top: 50px;">

                  <div style="width: 450px; text-align: center; margin: 0 auto;" *ngIf="innerHtml" [innerHTML]="innerHtml"></div>

                  <div *ngFor="let package of packages" class="col-md-12">

                     <p style="margin-top: 20px; text-align: center; color: black; font-size: 1.4rem; line-height: 30px;">
                       <span style="font-weight: 500;">Tracking Number#</span>  {{package.trackingNumber}}<br>

                       <span style="font-weight: 500;">Tracking Status:</span>  {{valor(this.shipment.trackingStatus)}}<br>

                       <span style="font-weight: 500;">Cost:</span>  {{this.shipment.shipmentCostAmount}} {{this.shipment.shipmentCostCurrency}} <br>

                       <span *ngIf="package.insuredValueAmount != '0.00' && package.insuredValueAmount != '0' && package.insuredValueAmount != '' && package.insuredValueAmount != 0 &&
                                  package.insuredValueAmount != null && package.insuredValueAmount != undefined">
                          <span style="font-weight: 500;">Insured Amount:</span>  {{package.insuredValueAmount}} {{package.insuredValueCurrency}}<br>
                       </span>

                     </p>
                      <p style="text-align: center; font-size: 1.3rem; color: brown; font-weight: 600;">
                        <a target="_blank" [href]="this.shipment.labelDownloadHref">
                          <span class="material-icons">print</span> Print Label
                        </a>
                      </p>

                  </div>

                  <div class="col-md-12">

                    <p style="text-align: center; font-size: 1.3rem; font-weight: 600;" class="{{ !sendingmail ? 'blue' : 'grey'}}">
                      <a target="_blank" (click)="sendMail()" style="cursor: pointer;">
                        <i *ngIf="sendingmail" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                        <span *ngIf="!sendingmail" class="material-icons">mail</span> Email to customer
                      </a>
                    </p>

                  </div>

                </div>

               <div class="row">
                <div mat-dialog-actions>
                  <button mat-button class="btn btn-rose" (click)="close()"  cdkFocusInitial>Close</button>
                </div>
              </div>

          </div>
        </div>
      </div>
    </div>
</div>